import React from "react"
import { Container } from "react-bootstrap"
import logo from "../../images/logo.png"

export default function CenteredContainer({ children }) {
  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}>
      
      
      <div className="w-100" style={{ maxWidth: "400px" }}>
      <div className='w-100 text-center mb-2'>
          <img src={logo} alt='logo' style={{ maxWidth: '300px'}}></img>
      </div>

        {children}
      </div>
    </Container>
  )
}
